import React from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { Close, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../../helpers";

const LearnAboutTiers: React.FunctionComponent<{
  onSetShowDrugTierHelp: (b: boolean) => void;
}> = ({ onSetShowDrugTierHelp }) => {
  const t = useTranslate();

  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        heading={t("plan_terms.learn_about_tiers")}
        onCloseClick={(): void => onSetShowDrugTierHelp(false)}
        closeButtonText={<Close />}
        ariaLabel={t("plan_terms.close_drug_tier_help_drawer")}
      >
        <p>{t("plan_terms.drug_tiers_description")}</p>
        <h4 className="ds-u-margin-bottom--0">
          <FormattedMessage
            id="plan_terms.tier-number"
            tagName="span"
            values={{ tier: 1 }}
          />
        </h4>
        <p className="ds-u-margin-top--1">
          {t("plan_terms.tier_1_description")}
        </p>

        <h4 className="ds-u-margin-bottom--0">
          <FormattedMessage
            id="plan_terms.tier-number"
            tagName="span"
            values={{ tier: 2 }}
          />
        </h4>
        <p className="ds-u-margin-top--1">
          {t("plan_terms.tier_2_description")}
        </p>

        <h4 className="ds-u-margin-bottom--0">
          <FormattedMessage
            id="plan_terms.tier-number"
            tagName="span"
            values={{ tier: 3 }}
          />
        </h4>
        <p className="ds-u-margin-top--1">
          {t("plan_terms.tier_3_description")}
        </p>

        <h4 className="ds-u-margin-bottom--0">
          <FormattedMessage
            id="plan_terms.tier-number"
            tagName="span"
            values={{ tier: 4 + ` ${t("plan_terms.tier_help_higher")}` }}
          />
        </h4>
        <p className="ds-u-margin-top--1">
          {t("plan_terms.tier_4_description")}
        </p>
      </HelpDrawer>
    </div>
  );
};

export default LearnAboutTiers;
